import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

import CardBlogReViewItemList from 'src/@core/components/blog-review/CardBlogReViewItemList'

import Grid from '@mui/material/Grid'
import Accordion from '@mui/material/Accordion'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

import { emphasize, styled } from '@mui/material/styles'

// ** Utils
import isEmpty from 'lodash/isEmpty'

//  Services
import { useReviewData } from '../../@core/services/firestore/hooks/useReviewData'

// import { useLessonData } from 'src/@core/services/firestore/hooks/useLessonData'

// ** Themes

// eslint-disable-next-line no-unused-vars
const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'transparent',
  height: 30,
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightRegular,
  ':hover,:focus': {
    color: 'white',
    backgroundColor: emphasize(theme.palette.primary.light, 0.06)
  },
  ':active': {
    boxShadow: theme.shadows[1],
    backgroundColor: emphasize(theme.palette.primary.light, 0.12)
  }
}))

// eslint-disable-next-line no-unused-vars
const StyledAccordion = styled(Accordion)(({ theme }) => {
  return {
    '& .MuiAccordionDetails-root': {
      padding: 0
    },
    '& .Mui-expanded': {
      minHeight: '34px !important'
    },
    '& .MuiAccordionSummary-root .Mui-expanded': {
      minHeight: '34px !important',
      marginTop: 12,
      marginBottom: 0
    }
  }
})

// eslint-disable-next-line no-unused-vars
const BookInfo = props => {
  // ** Hook
  const reviewHookData = useReviewData()
  const router = useRouter()

  useEffect(() => {
    if (!isEmpty(props.reviewData)) {
      //
      const testDate = props.reviewData.testDate
      getCurrentData(testDate)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.reviewData])

  async function getCurrentData(testDate) {
    await reviewHookData.actions.getRelatedData(testDate)
  }

  const handleClickItem = blogInfo => {
    const path = `/ielts-review/${blogInfo.slug}`
    router.push({
      pathname: path
    })
  }

  return (
    <Grid container spacing={6}>
      <Grid item xs={12}>
        {!isEmpty(props.reviewData) && (
          <CardBlogReViewItemList
            needBadge={false}
            needAction={false}
            isFull={true}
            key={props.reviewData._id}
            isFeedback={false}
            itemData={props.reviewData}
            itemIndex={0}
          />
        )}
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h5'>{'Review gần đây'}</Typography>
        <Typography variant='body2'>{'Được đề xuất cho bạn'}</Typography>
      </Grid>

      {reviewHookData.reviewDataList.map((reviewItemData, reviewItemIndex) => (
        <CardBlogReViewItemList
          needBadge={false}
          needAction={false}
          key={reviewItemData._id}
          isFeedback={false}
          itemData={reviewItemData}
          itemIndex={reviewItemIndex}
          onClickItem={handleClickItem}
        />
      ))}
    </Grid>
  )
}

export default BookInfo
